module.exports = __webpack_public_path__ + "static/img/greeen-arrow.6c5db4e7.png";